import React from 'react'
import {Card, CardHeader, CardFooter, CardBody, Text,Box,Form,FormField,Layer,Button,TextInput} from 'grommet'
import {FormClose,ContactInfo, Organization, Add, FormUpload} from 'grommet-icons';
import { withRouter } from 'react-router-dom';
import { Auth,API } from 'aws-amplify';

function CreateDepartmentLayer(props){
    const [org] = React.useState(props.org)
    const [department, setDepartment] = React.useState()
    const [show, setShow] = React.useState();
    // useEffect( () => {
    //   if (lab.name !== props.lab.name){
    //     setLab(props.lab)
    //   }
    // }, [props.lab])
    const reloadShipment = () => {
      setShow(false)
    }


   function handleSubmit(){
     department.organisation_id = org.id
        Auth.currentSession().then(session => {
        API
        .post("LabShip", `/departments`,
        { headers: { 
            Authorization: session.idToken.jwtToken,
        }, 
        body:department})
        .then(updatedOrg => {
            props.history.push({pathname: `/admin/organisations/all`})
        }).then(a => {
          setShow(false)
            props.history.push({pathname: `/admin/organisations/edit/${org.id}`})
        })
        })
    }
    return (
        <Box>
            <Button margin='large' hoverIndicator label='Add Department' icon={<Add color='brand' />} onClick={() => setShow(true)} />
        {show && (
          <Layer
            onEsc={() => reloadShipment()}
            onClickOutside={() => reloadShipment()}
          >
            <Card pad='small' margin='small'>
            <CardHeader pad='small'>
                <Button onClick={() => {setShow(false)}} size='xsmall' hoverIndicator icon={<FormClose color='brand' />}  />
                <Text alignSelf='center' size='large'>Create Department for {org.name}</Text>
                <Organization color='brand' />
                </CardHeader>
            <CardBody>
            <Form value={department} onChange={(nextValue) => setDepartment(nextValue)} onSubmit={handleSubmit} handleSubmit={handleSubmit}>
            <Box direction='row'>
              <FormField borderSize='xsmall' width='medium' label={<Text size='xsmall'>Department</Text>} name='name' margin='small' >
                <TextInput size='xsmall' icon={<ContactInfo />} name='name' placeholder="Department" />
              </FormField>
              </Box>
            </Form>
            </CardBody>
            <CardFooter>
              <Button onClick={handleSubmit} size='small' margin='small' label="Create Department" icon={<FormUpload color='brand' />}  />
            </CardFooter>
            </Card>
          </Layer>
        )}
      </Box>
    )
}

export default withRouter(CreateDepartmentLayer)
